import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lapidary'
import type { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = Readonly<
  WithRequiredTheme & {
    size?: number
  }
>

export const container: CSSObject = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  paddingBlockStart: Spacing.S * 11,
}

export const content: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  inlineSize: Spacing.XL * 9.875,
  justifyContent: 'center',
  marginInlineEnd: 'auto',
  marginInlineStart: 'auto',
  ...modernWithFallback(
    [
      { maxInlineSize: `calc(100vi - ${Spacing.M}px)` },
      { maxInlineSize: `calc(100vw - ${Spacing.M}px)` },
    ],
    'width: 1vi'
  ),
}

export const formTitle: CSSObject = {}

export const fieldset: CSSObject = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  margin: 0,
  padding: 0,
}

export const siblingFieldset: CSSObject = {
  marginBlockStart: Spacing.L,
}

export const avatarUploader: CSSObject = {
  ...fieldset,
  ...siblingFieldset,
  justifyContent: 'start',
}

export const avatar = ({ size, theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.N200,
  color: Color[theme].Text.Gray,
  alignItems: 'center',
  aspectRatio: '1 / 1',
  blockSize: size,
  borderRadius: '50%',
  boxSizing: 'border-box',
  display: 'flex',
  fontSize: size ? size * 0.4 : size,
  inlineSize: size,
  justifyContent: 'center',
  marginInlineEnd: Spacing.S * 1.5,
  ...modernWithFallback(
    [
      {
        maxBlockSize: '30vb',
        maxInlineSize: '30vi',
      },
      {
        maxBlockSize: '30vw',
        maxInlineSize: '30vw',
      },
    ],
    'width: 1vi'
  ),
})

export const email: CSSObject = {
  ...fieldset,
  ...siblingFieldset,
}

export const jobTitle: CSSObject = {
  ...fieldset,
  ...siblingFieldset,
}

export const name: CSSObject = {
  ...fieldset,
  marginBlockStart: Spacing.L * 1.5,
}

export const terms: CSSObject = {
  ...fieldset,
  ...Typography.T300,
  alignItems: 'center',
  marginBlockStart: Spacing.M,
  justifyContent: 'flex-start',
}

export const checkbox: CSSObject = {
  marginInlineEnd: Spacing.S,
}

export const footer: CSSObject = {
  marginBlockStart: Spacing.L * 1.5,
}
